import { render } from "./WaitingLoot.vue?vue&type=template&id=8bda84ce&scoped=true"
import script from "./WaitingLoot.vue?vue&type=script&lang=js"
export * from "./WaitingLoot.vue?vue&type=script&lang=js"

import "./WaitingLoot.vue?vue&type=style&index=0&id=8bda84ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bda84ce"]])

export default __exports__